const counterMax = 0xfff;
// cast: Web Crypto is global in Node ≥ 19, browsers and the POS webview, but this package compiles without
// DOM or Node types so it stays platform-neutral.
const webCrypto = globalThis.crypto;
function randomBytes(length) {
    return webCrypto.getRandomValues(new Uint8Array(length));
}
function hex(bytes) {
    let out = "";
    for (const byte of bytes)
        out += byte.toString(16).padStart(2, "0");
    return out;
}
/** A generator with its own state. `clock` returns Unix milliseconds; tests pass a fake one. */
export function createIdGenerator(clock = Date.now) {
    let lastMs = -1;
    let counter = 0;
    return () => {
        const now = clock();
        if (now > lastMs) {
            lastMs = now;
            const [high = 0, low = 0] = randomBytes(2);
            counter = ((high << 8) | low) & 0x7ff;
        }
        else if (counter < counterMax) {
            counter += 1;
        }
        else {
            lastMs += 1;
            counter = 0;
        }
        const tail = randomBytes(8);
        tail[0] = ((tail[0] ?? 0) & 0x3f) | 0x80; // variant 10xx
        const value = lastMs.toString(16).padStart(12, "0") + (0x7000 | counter).toString(16) + hex(tail);
        return `${value.slice(0, 8)}-${value.slice(8, 12)}-${value.slice(12, 16)}-${value.slice(16, 20)}-${value.slice(20)}`;
    };
}
/** Generates a UUIDv7. Use this for every new row ID, on the server and on the POS. */
export const newId = createIdGenerator();
/** The Unix-millisecond timestamp embedded in a UUIDv7. */
export function idTimestamp(id) {
    return Number.parseInt(id.slice(0, 8) + id.slice(9, 13), 16);
}
//# sourceMappingURL=id.js.map